import { getParamsUrl } from '@/helpers/request'
import Repository from './Repository'

const action = 'handle-unknown-files'
const isProd = process.env.NODE_ENV === 'production'
const baseURL = isProd
  ? process.env.VUE_APP_API_URL_PROD
  : process.env.VUE_APP_API_URL
const token = process.env.VUE_APP_HARDWARE_TOKEN

export default {
  getHardware: () => Repository.get(`${action}/hardware-users`),
  getUnknownDocs: (params = {}) =>
    Repository.get(`${action}/unknown-documents` + getParamsUrl(params)),
  getTtnBids: (params = {}) =>
    Repository.get(`${action}/ttn-bids-search` + getParamsUrl(params)),
  getTtnResponses: (params = {}) =>
    Repository.get(`${action}/ttn-responses-search` + getParamsUrl(params)),
  ttnInput: data => Repository.post(`${action}/ttn-input`, data),
  generateImgUrls: (ids = []) =>
    ids.map(id => ({
      id,
      url: `${baseURL}${action}/display-file${getParamsUrl({
        id,
        token,
        v: Number(new Date()),
      })}`,
    })),
}
